import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApiClientService,
  IBank,
  ICreatePayoutAccountPayload,
  IPaginatedResponse,
  IPayoutAccount,
  IResolveBankAccountPayload,
  IResolveResult,
  IUpdatePayoutAccountLabelPayload,
  TENANT_API
} from '@pharvio/core/shared';
import { PayoutAccountsDataService } from './repositories/payout-accounts-data.service';

@Injectable()
export class HttpPayoutAccountsDataService extends PayoutAccountsDataService {
  private readonly api = inject(ApiClientService);

  getAccounts(): Observable<IPaginatedResponse<IPayoutAccount>> {
    return this.api.get<IPaginatedResponse<IPayoutAccount>>(
      TENANT_API.PAYOUT_ACCOUNTS.BASE
    );
  }

  createAccount(
    payload: ICreatePayoutAccountPayload
  ): Observable<IPayoutAccount> {
    // Step-up protected: a 403 names the operation in `details`, which the
    // step-up interceptor picks up — nothing to declare here.
    return this.api.post<IPayoutAccount>(
      TENANT_API.PAYOUT_ACCOUNTS.BASE,
      payload
    );
  }

  archiveAccount(id: string): Observable<void> {
    return this.api.post<void>(TENANT_API.PAYOUT_ACCOUNTS.ARCHIVE(id), {});
  }

  updateLabel(
    id: string,
    payload: IUpdatePayoutAccountLabelPayload
  ): Observable<IPayoutAccount> {
    return this.api.patch<IPayoutAccount>(
      TENANT_API.PAYOUT_ACCOUNTS.LABEL(id),
      payload
    );
  }

  getBanks(): Observable<IBank[]> {
    return this.api.get<IBank[]>(TENANT_API.BANKS.BASE);
  }

  resolveBankAccount(
    payload: IResolveBankAccountPayload
  ): Observable<IResolveResult> {
    return this.api.post<IResolveResult>(
      TENANT_API.PAYOUT_ACCOUNTS.RESOLVE,
      payload
    );
  }
}
